import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function seca(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@seca/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@seca/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@seca/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@seca/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@seca/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@seca/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}